import React, { useId } from 'react';

// Champs simples pouvant recevoir un id relié au libellé
const LABELLABLE = ['input', 'select', 'textarea'];

export const Field = ({ label, required, error, hint, children }) => {
  const id = useId();
  const labellable = React.isValidElement(children)
    && (LABELLABLE.includes(children.type) || [TextInput, NumberInput, Select].includes(children.type));
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={labellable ? id : undefined}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      {labellable ? React.cloneElement(children, { id }) : children}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export const TextInput = ({ error, type = 'text', ...props }) => (
  <input type={type} className={error ? 'error' : ''} {...props} />
);

export const NumberInput = ({ error, value, onChange, max = 100, ...props }) => (
  <input
    type="number"
    min="0"
    max={max}
    inputMode="numeric"
    className={error ? 'error' : ''}
    value={value || ''}
    placeholder="0"
    onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
    {...props}
  />
);

export const Select = ({ error, options, placeholder = 'Sélectionner…', ...props }) => (
  <select className={error ? 'error' : ''} {...props}>
    <option value="">{placeholder}</option>
    {options.map(o => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </select>
);

export const YesNo = ({ name, value, onSelect }) => (
  <div className="radio-group">
    {[{ v: true, label: 'Oui' }, { v: false, label: 'Non' }].map(({ v, label }) => (
      <label key={label} className={`radio-option ${value === v ? 'selected' : ''}`}>
        <input type="radio" name={name} checked={value === v} onChange={() => onSelect(v)} />
        {label}
      </label>
    ))}
  </div>
);

export const MultiSelect = ({ options, selected, onChange }) => {
  const toggle = (value) => onChange(
    selected.includes(value) ? selected.filter(v => v !== value) : [...selected, value],
  );
  return (
    <div className="checkbox-group">
      {options.map(opt => (
        <label key={opt.value} className={`checkbox-option ${selected.includes(opt.value) ? 'selected' : ''}`}>
          <input type="checkbox" checked={selected.includes(opt.value)} onChange={() => toggle(opt.value)} />
          {opt.label}
        </label>
      ))}
    </div>
  );
};

export const Check = ({ name, data, onChange, error, children }) => (
  <label className={`checkbox-single ${data[name] ? 'checked' : ''} ${error ? 'error' : ''}`}>
    <input
      type="checkbox"
      name={name}
      checked={!!data[name]}
      onChange={(e) => onChange({ [name]: e.target.checked })}
    />
    <span>{children}</span>
  </label>
);
